/**
 * This hook runs a provided callback when clicked outside of a target.
 * Useful for closing dropdowns and popups easily.
 *
 * You must attach the returned dom ref to an HTML element,
 * NOT A REACT COMPONENT.
 */
import { useEffect, useRef } from 'react';
export default function useOnClickOutside(callback) {
  const domRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const listener = (event: Event) => {
      if (domRef.current && !domRef.current.contains(event.target as Node)) {
        callback(event);
      }
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, []);

  return domRef;
}
